import React from 'react';
import { useQuery } from 'react-query';
import axios from 'axios';
import { API_URL } from '../../../../links/API_LINKS';
import CircularProgress from '@mui/material/CircularProgress';
import { Box } from '@mui/material';
import AreaHeader from './AreaHeader';

const Index = () => {
  const fetchAreas = async () => {
    const res = await axios.get(API_URL + '/area', {
      params: { limit: 0, includeDeleted: true },
    });
    return res;
  };
  const { status, data } = useQuery('fetchAreas', fetchAreas);

  return (
    <div>
      {status === 'loading' && (
        <Box
          display='flex'
          justifyContent='center'
          alignItems='center'
          minHeight='50vh'
        >
          <CircularProgress />
        </Box>
      )}
      {status === 'error' && <div>Error fetching data</div>}
      {status === 'success' && (
        <Box>
          <AreaHeader data={data.data.data} />{' '}
        </Box>
      )}
    </div>
  );
};

export default Index;
